import type { Attachment } from 'stream-chat';
import { MediaFileWithPreview } from '@features/components/Chat/components/ChatContent/Messages/types/mediaFiles';
import {
  ClinicalDataAttachmentImage,
  ClinicalDataAttachmentMedia,
  ClinicalDataAttachmentVideo,
} from '@features/components/Chat/components/ChatContent/Messages/types/chatMessages';
import { getFileUrl } from '@/api/utils';

const VIDEO_KEY_INDICATOR = 'thumbnail';

export const mapChatMediaFilesForRender = (mediaFiles: ClinicalDataAttachmentMedia[]): Attachment[] => {
  if (!mediaFiles || mediaFiles.length === 0) {
    return [];
  }

  return mediaFiles.map((mediaFile: ClinicalDataAttachmentMedia) => {
    const { fileName, remoteURL } = mediaFile;

    if (VIDEO_KEY_INDICATOR in mediaFile) {
      return {
        type: 'video',
        title: fileName,
        asset_url: remoteURL,
        fallback: fileName,
      };
    }

    return {
      type: 'image',
      title: fileName,
      image_url: remoteURL,
      fallback: fileName,
    };
  });
};

const createVideoDTO = (file: MediaFileWithPreview): ClinicalDataAttachmentVideo => ({
  fileId: file.fileId,
  fileName: file.fileName,
  details: file.details ?? '',
  duration: file.duration!,
  remoteURL: getFileUrl(file.path),
  thumbnail: {
    fileId: file.preview!.fileId,
    fileName: file.preview!.fileName,
    remoteURL: getFileUrl(file.preview!.path),
    details: '',
  },
});

const createImageDTO = (file: MediaFileWithPreview): ClinicalDataAttachmentImage => ({
  fileId: file.fileId,
  fileName: file.fileName,
  remoteURL: getFileUrl(file.path),
  details: file.details ?? '',
});

export const createChatMediaFilesDTO = (mediaFiles: MediaFileWithPreview[]): ClinicalDataAttachmentMedia[] => {
  return mediaFiles.map((file: MediaFileWithPreview) => {
    return file.mediaType === 'Video' && file.preview ? createVideoDTO(file) : createImageDTO(file);
  });
};
